<template>
  <CheckBoxField
    :scope="[...scope, 'required']"
    :initial-value="required"
    :errors="errors['required']"
  />
  <CheckBoxField
    :scope="[...scope, 'editable']"
    :initial-value="editable"
    :errors="errors['editable']"
  />
  <CheckBoxField
    :scope="[...scope, 'public']"
    :initial-value="public"
    :errors="errors['public']"
  />
  <LocaleStringField
    :scope="[...scope, 'label']"
    :locales="locales"
    :initial-value="label"
    :errors="errors['label']"
  />
  <LocaleStringField
    :scope="[...scope, 'help']"
    :optional="true"
    :locales="locales"
    :initial-value="help"
    :errors="errors['help']"
  />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { humanize, scopeToName } from "@/lib/candidacy/form_builder/utils";
import type { EveryBuildableItem, Locale, PropType } from "@/types";
import LocaleStringField from "@/components/backend/candidacy/form_builder/form_items/shared/LocaleStringField.vue";
import CheckBoxField from "@/components/backend/candidacy/form_builder/form_items/shared/CheckBoxField.vue";
import TextField from "@/components/backend/candidacy/form_builder/form_items/shared/TextField.vue";

export default defineComponent({
  name: "InformationItem",
  components: { TextField, CheckBoxField, LocaleStringField },
  methods: { scopeToName, humanize },
  props: {
    initialItem: {
      type: Object as PropType<EveryBuildableItem>,
      required: true,
    },
    scope: {
      type: Array as PropType<string[]>,
      default: []
    },
    locales: {
      type: Array as PropType<Locale[]>,
      default: ["en"],
    },
  },
  data() {
    const initialItem: EveryBuildableItem = this.initialItem;
    return {
      id: initialItem.id,
      type: initialItem.type,
      item_type: initialItem.item_type,
      required: initialItem.required ?? false,
      editable: initialItem.editable ?? true,
      public: initialItem.public ?? true,
      config: initialItem.config || {},
      label: initialItem.label || {},
      help: initialItem.help || {},
      errors: initialItem.errors || {},
    }
  },
});
</script>
